import React, { useState } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Col,
  CardHeader,
  CardBody,
} from "reactstrap";
import classnames from "classnames";
import type { StatusBucketMetrics } from "../../utils/dashboardMetrics";
import { formatDashboardMoney } from "../../utils/dashboardMetrics";

interface TradingProps {
  bookingStatus: {
    confirmed: StatusBucketMetrics;
    pending: StatusBucketMetrics;
    cancelled: StatusBucketMetrics;
  };
  orderStatus: {
    confirmed: StatusBucketMetrics;
    pending: StatusBucketMetrics;
    cancelled: StatusBucketMetrics;
  };
  currency?: string;
  loading?: boolean;
}

const StatusRows = ({
  status,
  currency,
}: {
  status: TradingProps["bookingStatus"];
  currency?: string;
}) => (
  <>
    {(
      [
        { key: "confirmed", label: "Confirmed", color: "success" },
        { key: "pending", label: "Pending", color: "warning" },
        { key: "cancelled", label: "Cancelled", color: "danger" },
      ] as const
    ).map((row) => (
      <div key={row.key} className="mb-3">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h5 className="font-size-14 mb-1">{row.label}</h5>
            <p className="text-muted mb-0 font-size-12">
              {status[row.key].count} records
            </p>
          </div>
          <div className="text-end">
            <h5 className={`font-size-14 text-${row.color} mb-0`}>
              {formatDashboardMoney(status[row.key].amount, currency)}
            </h5>
            <p className="text-muted mb-0 font-size-12">Amount</p>
          </div>
        </div>
      </div>
    ))}
  </>
);

const Trading = ({ bookingStatus, orderStatus, currency, loading }: TradingProps) => {
  const [activeTab, setActiveTab] = useState<string>("1");

  const toggle = (tab: any) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <React.Fragment>
      <Col xl={4}>
        <Card>
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">Status Summary</h4>
            <div className="flex-shrink-0">
              <Nav className="nav-tabs-custom card-header-tabs" role="tablist">
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      toggle("1");
                    }}
                  >
                    Orders
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => {
                      toggle("2");
                    }}
                  >
                    Bookings
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </CardHeader>

          <CardBody>
            {loading ? (
              <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <h5 className="font-size-14 mb-4">Order Status</h5>
                  <StatusRows status={orderStatus} currency={currency} />
                </TabPane>
                <TabPane tabId="2">
                  <h5 className="font-size-14 mb-4">Booking Status</h5>
                  <StatusRows status={bookingStatus} currency={currency} />
                </TabPane>
              </TabContent>
            )}
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default Trading;
